// @flow
import * as React from 'react'
import styled from 'styled-components'
import { H290 } from './shared'
import Badges from './Badges'
import { config, Hidden } from 'react-awesome-styled-grid'
import { colors } from '../components/shared/colors'

type PropsType = {
  title?: string,
  color?: string,
  signup?: boolean,
  children?: React.Node
}
export default function DriveToDownloadBlock ({ title, color, signup }: PropsType): React.Node {
  return (
    <CenterDiv>
      <Hidden xs={true} sm={true} md>
        <LogoImg src='/images/dipsea-logo.png' />
      </Hidden>
      <Header color={color}>{title || 'Find your favorite fantasy.'}</Header>
      <Badges color={color} signup={signup} badgesOnly />
    </CenterDiv>
  )
}

const CenterDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const LogoImg = styled.img`
  display: block;
  margin-bottom: 20px;
  width: 86px;
`
const Header = styled(H290)`
  text-align: center;
  color: ${(props: any): string => props.color || colors.sand};
  margin-bottom: 28px;
  margin: 0 auto 28px;
  width: 280px;
  font-size: 45px;
  line-height: 110%;
  ${(props: any): string => config(props).media.md`
    margin-bottom: 20px;
    width: unset;
  `}
  ${(props: any): string => config(props).media.lg`
    margin-bottom: 28px;
    font-size: 90px;
    line-height: 105%;
  `}
`
